import { KYMW1704Model } from '../kymw1704.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * 画面再表示時の情報取得するサービス
 *
 * @export GetBillingNameService
 * @class GetBillingNameService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetBillingNameService extends PlessJsonResponderSub<any> {

  private billingCode: string;

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1704Model}
   * @memberof GetBillingNameService
   */
  private model: KYMW1704Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetBillingNameService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetBillingNameService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        SupplierCode: this.billingCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetBillingNameService
   */
  execute(model: any, billingCode: string , successFunc: Function): void {
    this.model = <KYMW1704Model> model;
    this.billingCode = billingCode;
    this.successFunc = successFunc;
    this.send('KYMW0C00GetSupplierName', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetBillingNameService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
